import styled, { css } from 'styled-components';

import {
    mediaMixin,
    spaceMixin,
    Spacer,

} from '@zillow/constellation';

export const StyledSpacer = styled(Spacer)`
    margin-bottom: ${spaceMixin('xs')};

    ${mediaMixin('lg', css`
        margin-bottom: ${spaceMixin('sm')};
    `)}
`;
